import React, { useState, useEffect } from "react";
import "./Navbar.scss";
import RoutingMenu from "../RoutingMenu/RoutingMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { Box, TextField } from "@mui/material";
import { useAuth } from "../../store/context/auth";
import AccountsAndProfileModal from "./AccountsAndProfileModal";
import SearchIcon from "../../images/search.svg";
import RoleBadge from "./UserProfile";
import AdminCenter from "./AdminCenter";
import { getUserDetails } from "../../util/API/customers";
import UserFace from "../../images/user.png";
import { decodeHtmlEntities } from "../../util/utilfunctions/utilFunctions";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";

const loanModules = [
  { label: "Enquiries", path: "/loans/enquiries" },
  { label: "Applications", path: "/loans/applications" },
  { label: "Document processing", path: "/loans/document-processing" },
  { label: "Credit scoring", path: "/loans/credit-scoring" },
  { label: "Disbursements", path: "/loans/disbursements" },
  { label: "Account servicing", path: "/loans/account-servicing" },
  { label: "Early warning", path: "/loans/early-warning" },
  { label: "Restructuring", path: "/loans/restructuring" },
  { label: "Portfolio reporting", path: "/loans/portfolio-reporting" },
];
 
function Navbar({ hide, onMenuIconClick }) {
  const [header, setHeader] = useState("");
  const [isProfileOptionsVisible, setIsProfileOptionsVisible] = useState(false);
  const [isLoanMenuVisible, setIsLoanMenuVisible] = useState(false);
  const [open, setOpen] = useState({
    account: false,
    admincenter: false,
  });
  const [pictureData, setPictureData] = useState({
    photo: "",
    base64Image: "",
});
  const [searchInput, setSearchInput] = useState("");
  let configVariables = useSelector((state) => state.config.baseConfig);
  let imageUrl = configVariables.imageURL;
 
  // console.log(configVariables)
 
  const portalLogo = configVariables.logoURL
 
  // console.log(portalLogo)
 
  const location = useLocation();
  const auth = useAuth();
  const scrollPosition = useSelector((state) => state.scroll.position);
  const firstName = useSelector((state) => state.login?.user?.firstName);
  const otherNames = useSelector((state) => state.login?.user?.otherNames);
  if (!firstName & !otherNames) {
    auth.logout();
    sessionStorage.clear();
  }
 
  const navigate = useNavigate();
 
  const baseUrl = `${window.location.protocol}//${window.location.host}`;
  // console.log(baseUrl);
 
  const requiredConstants = useSelector((state) => state.constants);
  let isSuperAdmin = sessionStorage.getItem("isSuperAdmin");
  let isAdmin = sessionStorage.getItem("isAdmin");
  let isAssociateAdmin = sessionStorage.getItem("isAssociateAdmin");
  let isLoanAdmin = sessionStorage.getItem("isLoanAdmin");
  
  let user = useSelector((state) => state.login);
 
  const [role, setRole] = useState([]);
  const userRoleId = sessionStorage.getItem("userSecurityRoleId");
    const payrollAdminId = configVariables?.payRollAdminId
    ? String(configVariables.payRollAdminId).trim()
    : "";
    const isExternalPayrollAdmin =
    payrollAdminId !== "" && userRoleId === payrollAdminId;
  // console.log(isAssociateAdmin)
  // console.log(isAdmin)
 
  // console.log(isSuperAdmin);
  const systemRoles = async () => {
    const userSecurityRole = user["securityRole"];
 
    if (Array.isArray(userSecurityRole)) {
      // If securityRole is an array, collect all roles
      const roles = userSecurityRole.flatMap((role) =>
        requiredConstants.systemRoles.filter(
          (systemRole) => systemRole.securityrole.roleid === role.roleid
        )
      );
      setRole(roles || []);
    } else if (userSecurityRole && typeof userSecurityRole === "object") {
      // If securityRole is an object, process as a single role
      const role = requiredConstants.systemRoles.filter(
        (systemRole) =>
          systemRole.securityrole.roleid === userSecurityRole.roleid
      );
      setRole(role || []);
    } else {
      setRole([]);
    }
  };
 
  useEffect(() => {
    systemRoles();
  }, []);
 
  useEffect(() => {
    async function getUserData() {
      if (pictureData.photo) return;

      try {
        const userDetails = await getUserDetails(user["user"].id);
        const photo = userDetails?.User?.photo;

        if (photo) {
          setPictureData({
            photo: imageUrl + photo,
            base64Image: imageUrl + photo,
          });
        }
      } catch (error) {
        // Profile imagery is optional. A missing/expired session must not prevent
        // the login screen or the rest of the navigation shell from rendering.
        console.warn("Unable to load the user's profile photo.", error);
      }
    }
 
    if (user["user"]?.id) {
      getUserData();
    }
  }, [imageUrl, pictureData.photo, setPictureData, user]);
 
  const names = {
    dashboard: "Dashboard",
    crm: "CRM",
    admin: "Admin",
    reporting: "Reporting",
    compliance: "Transaction Monitoring",
    batch: "Batch Services",
    Treasury: "Treasury",
    accounting: "Accounting",
    settings: "Admin Center",
    unauthorized: "unauthorized",
    loans: "Loans",
    agents: "Agents",
    devicemanagement: "Device Management",
  };
 
  useEffect(() => {
    const path = location.pathname.slice(1);
    setHeader(names[path]);
  }, [location.pathname]);
 
  const handleProfileIconClick = () => {
    setIsLoanMenuVisible(false);
    setIsProfileOptionsVisible((prev) => !prev);
  };
 
  const handleClickAway = () => {
    setIsProfileOptionsVisible(false);
    setIsLoanMenuVisible(false);
  };

  const isLoanRoute = location.pathname.startsWith("/loans/");
  const currentLoanModule = loanModules.find(({ path }) =>
    location.pathname === path || location.pathname.startsWith(`${path}/`)
  );

  const openLoanModule = (path) => {
    setIsLoanMenuVisible(false);
    navigate(path);
  };
 
  const handleCloseModal = () => {
    setOpen({ ...open, account: false, admincenter: false });
  };
 
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Box className={`${hide ? "hide" : "navbar"}`} sx={{ zIndex: 300 }}>
        <AccountsAndProfileModal
          open={open.account}
          handleCloseModal={handleCloseModal}
          role={role}
          pictureData={pictureData}
          setPictureData={setPictureData}
        />
        <AdminCenter isOpen={open.admincenter} handleClose={handleCloseModal} />

        <Box className="wrapper" sx={{ zIndex: 300 }}>
          <Box className="left-navbar">
            <TextField
              size="small"
              placeholder="Search Module"
              variant="outlined"
              value={searchInput}
              onChange={(e) => {
                const value = e.target.value;
                const capitalizedValue =
                  value.charAt(0).toUpperCase() + value.slice(1);
                setSearchInput(capitalizedValue);
              }}
              InputProps={{
                endAdornment: (
                  <img
                    src={SearchIcon}
                    alt="search-icon"
                    loading="lazy"
                    style={{
                      width: "20px",
                      height: "20px",
                      paddingLeft: "5px",
                    }}
                  />
                ),
              }}
              sx={{
                "& .MuiInputBase-input": {
                  padding: "5px 10px",
                },
                "& .MuiOutlinedInput-root": {
                  borderRadius: "50px", // Capsule effect for the outer border
                  paddingRight: "8px", // Padding to align text and icon properly
                  background: "#FFF",
                  border: "border: 1px solid var(--grey-grey-30, #eaeef4)",
                  height: "35px",
                  padding: "0px 10px 0px 10px",
                },
              }}
            />

            <Box className="navmenu">
              <RoutingMenu
                searchInput={searchInput}
                setSearchInput={setSearchInput}
                devEnvironment={configVariables.devEnvironment}
              />
            </Box>

            <Box className="navbar-text">{scrollPosition > 95 && header} </Box>
            <Box></Box>
          </Box>
          <img
            style={{ maxWidth: "300px", maxHeight: "75px" }}
            src={portalLogo}
            alt="Logo"
            loading="lazy"
          />
          <Box className="navitems">
            {/* <div className="navicons">
              <NotificationsNoneOutlinedIcon className="icons" />
              <div className="counter">1</div>
            </div>
            <div className="navicons">
              <MenuBookIcon className="icons" />
            </div> */}
            {isLoanRoute && (
              <Box className="loan-module-switcher">
                <button
                  type="button"
                  className={`loan-module-pill ${isLoanMenuVisible ? "is-open" : ""}`}
                  aria-haspopup="menu"
                  aria-expanded={isLoanMenuVisible}
                  onClick={() => {
                    setIsProfileOptionsVisible(false);
                    setIsLoanMenuVisible((visible) => !visible);
                  }}
                >
                  <span>LMS ::</span>
                  <strong>{currentLoanModule?.label || "Select module"}</strong>
                  <KeyboardArrowDownRoundedIcon
                    className="loan-module-chevron"
                    aria-hidden="true"
                  />
                </button>
                {isLoanMenuVisible && (
                  <Box className="loan-module-menu" role="menu">
                    <span className="loan-module-menu-title">Loan management</span>
                    {loanModules.map((module) => {
                      const active = currentLoanModule?.path === module.path;
                      return (
                        <button
                          type="button"
                          role="menuitem"
                          className={active ? "is-active" : ""}
                          aria-current={active ? "page" : undefined}
                          key={module.path}
                          onClick={() => openLoanModule(module.path)}
                        >
                          <span>{module.label}</span>
                          {active && <b>Current</b>}
                        </button>
                      );
                    })}
                  </Box>
                )}
              </Box>
            )}
            <Box className="navicons" onClick={handleProfileIconClick}>
              {/* <PersonOutlineOutlinedIcon className="icons" /> */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column", // Align items vertically
                  alignItems: "flex-end",
                }}
              >
                <p className="user-profile-name">
                  {decodeHtmlEntities(firstName)}{" "}
                  {decodeHtmlEntities(user?.user?.lastName)}
                </p>
                {/* <p className="user-profile-name">{user?.user?.lastName}</p> */}

                {isProfileOptionsVisible && (
                  <Box className="profile-options">
                    {/* <Box className="option">User Profile</Box>
                  <Box className="option">Change Password</Box>
                  <Box className="option">Change Profile Picture</Box>
                  <Box className="option">Settings</Box>
                  <Box className="option">Set Status</Box>
                  <Box className="option">Account Billing</Box> */}
                    <Box
                      className="option"
                      onClick={() => setOpen({ ...open, account: true })}
                    >
                      Account & Profile
                    </Box>
                    {!isExternalPayrollAdmin &&
                      (isSuperAdmin === "true" ||
                        (isAdmin === "true" && isAssociateAdmin === "false") ||
                        isLoanAdmin === "true") && (
                        <Box
                          className="option"
                          onClick={() =>
                            setOpen({ ...open, admincenter: true })
                          }
                        >
                          Admin Center
                        </Box>
                      )}
                    <Box
                      className="option"
                      onClick={() => {
                        auth.logout();
                        sessionStorage.clear();
                        navigate("/");
                      }}
                    >
                      Logout
                    </Box>
                  </Box>
                )}
                <RoleBadge roles={role} />
              </Box>

              <Box className="nav-dropdown-btn">
                <img
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "100%",
                    objectFit: "cover",
                  }}
                  src={
                    pictureData.photo == imageUrl || pictureData.photo == ""
                      ? UserFace
                      : pictureData.photo
                  }
                  alt="Logo"
                />
              </Box>
              {/* <PersonOutlineOutlinedIcon className="icons" /> */}
              <Box></Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </ClickAwayListener>
  );
}
 
export default Navbar;
